import React, { useRef, useState, useContext } from 'react';
import { IonModal, IonSlides, IonSlide, IonItem, IonInput, IonButton, IonCol, IonGrid, IonRow} from '@ionic/react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { SelectRoom } from './SelectRoom';

export function UpdateRoomBookedModal(props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [currentDate, setCurrentDate] = useState(props.endDate);

    let [newRoomID, setNewRoomID] = useState(null);
    let [numberOfNights_toCurrent, setDateRangeNumberOfNights_toCurrent] = useState(null);
    let [numberOfNights, setDateRangeNumberOfNights] = useState(null);

    function updateRoom()
    {

        /*let formData = new FormData();
        formData.append('Tracker', '74113_U_ROOM');
        formData.append('user', acctID);
        formData.append('xCheckInRoomID', props.currentRoom);
        formData.append('xCheckInUpdatedRoomID', newRoomID);
        //formData.append('xCheckInNumberOfNights_toCurrent', numberOfNights_toCurrent);
        formData.append('xCheckInNumberOfNights', numberOfNights);
        formData.append('xStartDateRange', props.startDate);
        //formData.append('xCurrentDateRange', currentDate.toISOString().substr(0, 10));
        formData.append('xEndDateRange', props.endDate);
        formData.append('xBookingID', props.bookingID);

        const requestOptions = {
            //enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74113_U_ROOM',
                user: acctID,
                xCheckInRoomID: props.currentRoom,
                xCheckInRoomID_multiple: props.currentRoom_multiple,
                xCheckInUpdatedRoomID: newRoomID,
                //xCheckInNumberOfNights_toCurrent: numberOfNights_toCurrent,
                xCheckInNumberOfNights: numberOfNights,
                xStartDateRange: props.startDate,
                //xCurrentDateRange: currentDate.toISOString().substr(0, 10),
                xEndDateRange: props.endDate,
                xBookingID: props.bookingID,
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
        })
        .catch(error => {
            console.error(error);
        })

    }


    function updateRoomHandler(event) {

        let date1_current = new Date(new Date(props.startDate.toLocaleString('en-US', {timeZone: 'Greenwich Mean Time',})));
        let date2_current = new Date(new Date());
        let timeDiff = Math.abs(date2_current.getTime() - date1_current.getTime());
        let calcNumberOfNights_current = Math.ceil(timeDiff / (1000 * 3600 * 24)); 

        let date1 = new Date(new Date(props.startDate.toLocaleString('en-US', {timeZone: 'Greenwich Mean Time',})));
        let date2 = new Date(new Date(props.endDate.toLocaleString('en-US', {timeZone: 'Greenwich Mean Time',})));
        let timeDiff2 = Math.abs(date2.getTime() - date1.getTime());
        let calcNumberOfNights = Math.ceil(timeDiff2 / (1000 * 3600 * 24)); 

        setNewRoomID(event.selectedRoomID);

        setCurrentDate(date2_current);
        setDateRangeNumberOfNights_toCurrent(calcNumberOfNights_current);
        setDateRangeNumberOfNights(calcNumberOfNights);

    }

    function closeModalHandler() {

        props.closeModal(false);
    }

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
                    <IonGrid> 
                        <IonRow>
                            <IonCol>
                                <label for='newDate'>Select Room: </label>
                            </IonCol>
                            <IonCol>
                                <SelectRoom openModal={ props.openModal } startDate={props.startDate} endDate={props.endDate} onCheckInRoomID={updateRoomHandler} selectRoomTracker={'74701R'} tracker={74701} ></SelectRoom>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonButton onClick={updateRoom}> Submit </IonButton> 
                            </IonCol>
                        </IonRow>
                    </IonGrid>                        
            <IonButton className='button_closeModal_center' onClick={closeModalHandler}>Cancel </IonButton>
        </IonModal>) : null}
    </React.Fragment>
    )
}